module.exports = __webpack_public_path__ + "static/media/alc-start.5c6d1531.png";